import { render } from "./NewsPage.vue?vue&type=template&id=1384252e&scoped=true"
import script from "./NewsPage.vue?vue&type=script&lang=js"
export * from "./NewsPage.vue?vue&type=script&lang=js"

import "./NewsPage.vue?vue&type=style&index=0&id=1384252e&scoped=scoped&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1384252e"]])

export default __exports__